export const OnetimePaymentsFailPageView = () => {
  return <div data-sentry-component="OnetimePaymentsFailPageView" data-sentry-source-file="OnetimePaymentsFailPageView.tsx">dasdas</div>;
};